import { render } from "./childrenTour.vue?vue&type=template&id=f203e9e2&scoped=true"
import script from "./childrenTour.vue?vue&type=script&lang=js"
export * from "./childrenTour.vue?vue&type=script&lang=js"

import "./childrenTour.vue?vue&type=style&index=0&id=f203e9e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f203e9e2"]])

export default __exports__